/* tslint:disable */
/* eslint-disable */
/**
 * UI schemas for iDeed ARCGx v2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const TriContractActionType = {
    DO_NOT_PROCEED: 'DO_NOT_PROCEED',
    PROCEED: 'PROCEED',
    ENRICH_AND_PROCEED: 'ENRICH_AND_PROCEED',
    CREATE: 'CREATE',
    PAY_AND_WALK: 'PAY_AND_WALK',
    UNI_UPLIFT: 'UNI_UPLIFT',
    CANCEL: 'CANCEL',
    UPLIFT: 'UPLIFT',
    AMEND: 'AMEND',
    TRANSFER: 'TRANSFER',
    CREATE_EXPIRE: 'CREATE_EXPIRE',
    ISSUE_EXPIRE: 'ISSUE_EXPIRE',
    DEMAND_FULL_PAYMENT: 'DEMAND_FULL_PAYMENT',
    DEMAND_PARTIAL_PAYMENT: 'DEMAND_PARTIAL_PAYMENT',
    DEMAND_PAID: 'DEMAND_PAID',
    SYSTEM_HOLD: 'SYSTEM_HOLD',
    SYSTEM_CONTINUE: 'SYSTEM_CONTINUE',
    SYSTEM_UPLIFT: 'SYSTEM_UPLIFT',
    UPDATE_REFERENCE: 'UPDATE_REFERENCE'
} as const;
export type TriContractActionType = typeof TriContractActionType[keyof typeof TriContractActionType];


export function TriContractActionTypeFromJSON(json: any): TriContractActionType {
    return TriContractActionTypeFromJSONTyped(json, false);
}

export function TriContractActionTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): TriContractActionType {
    return json as TriContractActionType;
}

export function TriContractActionTypeToJSON(value?: TriContractActionType | null): any {
    return value as any;
}

